import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "calendar",
  "use": "calendar-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"calendar\"><path d=\"M29 4H3a1 1 0 00-1 1v22a1 1 0 001 1h26a1 1 0 001-1V5a1 1 0 00-1-1zm-1 2v4H4V6zM10.67 18H4v-6h6.67zm2-6h6.66v6h-6.66zm8.66 0H28v6h-6.67zM4 26v-6h6.67v6zm8.67 0v-6h6.66v6zm8.66 0v-6H28v6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/calendar.svg
// module id = BQh+
// module chunks = 39 44